export default {
    namespaced: true,
    state: {
        internal:{
            type: 'info',
            msg: ''
        }
    },
    mutations: {
        showNotificationInternal (state, payload)
        {
            state.internal = {type:payload.type, msg: payload.msg};
        },
        clearNotificationInternal (state, payload)
        {
            state.internal = {type:'info', msg: ''};
        },
    }
};